module.exports = __webpack_public_path__ + "static/vmware_21.8be90869.jpg";